import React from "react";

export function FullStackDevSVG() {
  return (
    <>
      <svg
        className="w-90%"
        id="f0a8f4ba-cc2b-4400-9e08-d246a0bad060"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1098.75 632.37039"
      >
        <title>Full Stack Development</title>
        <ellipse
          cx="549.375"
          cy="600.77366"
          rx="549.375"
          ry="31.59674"
          fill="#E6E6E6"
        ></ellipse>
        <rect
          x="174.96748"
          width="825.31765"
          height="26.25696"
          fill="#E6E6E6"
        ></rect>
        <circle
          cx="197.05271"
          cy="12.74148"
          r="6.79546"
          fill="#fca311"
        ></circle>
        <circle
          cx="219.13794"
          cy="12.74148"
          r="6.79546"
          fill="#fca311"
        ></circle>
        <circle
          cx="241.22317"
          cy="12.74148"
          r="6.79546"
          fill="#fca311"
        ></circle>
        <polygon
          points="175.552 415.277 174.967 415.779 174.967 592.903 1000.285 592.903 1000.285 281.779 990.449 282.525 175.552 415.277"
          fill="#333244"
        ></polygon>
        <rect
          x="234.5289"
          y="175.64069"
          width="230.47032"
          height="9.29316"
          fill="#333244"
        ></rect>
        <rect
          x="234.5289"
          y="196.08564"
          width="230.47032"
          height="9.29316"
          fill="#333244"
        ></rect>
        <rect
          x="234.5289"
          y="216.53058"
          width="78.06253"
          height="9.29316"
          fill="#333244"
        ></rect>
        <rect
          x="704.5289"
          y="433.64069"
          width="230.47032"
          height="9.29316"
          fill="#fff"
        ></rect>
        <rect
          x="704.5289"
          y="454.08564"
          width="230.47032"
          height="9.29316"
          fill="#fff"
        ></rect>
        <rect
          x="704.5289"
          y="474.53058"
          width="78.06253"
          height="9.29316"
          fill="#fff"
        ></rect>
        <circle
          cx="561.33549"
          cy="575.26922"
          r="9.0658"
          fill="#E6E6E6"
        ></circle>
        <circle cx="587.6263" cy="576.1758" r="9.0658" fill="#E6E6E6"></circle>
        <circle
          cx="613.91711"
          cy="577.08238"
          r="9.0658"
          fill="#E6E6E6"
        ></circle>
        <circle
          cx="587.70943"
          cy="576.1758"
          r="7.25264"
          fill="#333244"
        ></circle>
        <rect
          x="310.5289"
          y="282.01368"
          width="78.06253"
          height="17.81006"
          fill="#333244"
        ></rect>
        <rect
          x="774.5289"
          y="523.01368"
          width="78.06253"
          height="17.81006"
          fill="#fff"
        ></rect>
        <circle
          cx="350"
          cy="291.01368"
          r="54"
          fill="#fca311"
          opacity="0.3"
        ></circle>
        <circle
          cx="350"
          cy="291.01368"
          r="36"
          fill="#fca311"
          opacity="0.3"
        ></circle>
        <circle cx="350" cy="291.01368" r="25" fill="#fca311"></circle>
        <circle
          cx="804.375"
          cy="157.1852"
          r="54"
          fill="#fca311"
          opacity="0.3"
        ></circle>
        <circle
          cx="804.375"
          cy="157.1852"
          r="36"
          fill="#fca311"
          opacity="0.3"
        ></circle>
        <circle cx="804.375" cy="157.1852" r="25" fill="#fca311"></circle>
        <circle
          cx="814"
          cy="532.01368"
          r="54"
          fill="#fca311"
          opacity="0.3"
        ></circle>
        <circle
          cx="814"
          cy="532.01368"
          r="36"
          fill="#fca311"
          opacity="0.3"
        ></circle>
        <circle cx="814" cy="532.01368" r="25" fill="#fca311"></circle>
        <rect
          x="141.09287"
          y="215.02041"
          width="22.24232"
          height="28.59727"
          transform="translate(244.80285 330.54921) rotate(-177.77929)"
          fill="#fca311"
        ></rect>
        <path
          d="M241.91491,314.67894s30.77895-14.70576,30.28646-2.00541-31.02521,21.05594-31.02521,21.05594Z"
          transform="translate(-50.625 -133.8148)"
          fill="#ffb9b9"
        ></path>
        <path
          d="M225.02834,422.13944S239.54941,457.681,244.9146,483.328s13.53608,60.94229,3.02582,85.97362-40.39191,98.59934-40.69972,106.53706,2.55946,15.99857-3.79071,15.75232-40.90677-11.12588-42.30963-15.95007,11.79-17.032,11.79-17.032l32.57732-102.08224L171.5182,490.02139l-24.51648,99.215-4.80184,123.82843s-23.56691-7.2736-26.98824-1.04655c0,0-10.55875-14.71883-11.90005-21.13057s4.98653-128.59106,4.98653-128.59106-21.63236-139.16289-4.16937-138.4857S189.99232,382.62245,225.02834,422.13944Z"
          transform="translate(-50.625 -133.8148)"
          fill="#000000"
        ></path>
        <path
          d="M203.69623,685.2408s16.10862,35.60315,17.63461,37.25226,12.02317,17.95548,4.08545,17.64767-26.68044-8.98428-40.47584-22.23869-31.98406-36.21877-30.33495-37.74475,12.9466-5.85768,12.9466-5.85768Z"
          transform="translate(-50.625 -133.8148)"
          fill="#000000"
        ></path>
        <path
          d="M139.33261,705.00394s.97192,15.937,3.90076,22.4103,2.55947,15.99856-5.37825,15.69075-28.45267-4.2832-28.45267-4.2832-1.21817-9.58683.43093-11.11281,8.67647-18.74272,5.68607-23.62847S139.33261,705.00394,139.33261,705.00394Z"
          transform="translate(-50.625 -133.8148)"
          fill="#000000"
        ></path>
        <path
          d="M127.58939,187.8209s-16.922,26.37263-23.51842,32.47656,11.9616,19.543,11.9616,19.543l33.2153,4.46789s-.41786-30.2249,1.29281-33.33842S127.58939,187.8209,127.58939,187.8209Z"
          transform="translate(-50.625 -133.8148)"
          fill="#ffb9b9"
        ></path>
        <path
          d="M156.45992,222.329s-6.84267,12.45411-13.19285,12.20786-39.1961-14.2394-40.599-19.0636-10.87963,34.5566-10.87963,34.5566L172.16,391.47053l19.60459-13.54915-9.49913-83.04478-7.80153-44.8206Z"
          transform="translate(-50.625 -133.8148)"
          fill="#fca311"
        ></path>
        <path
          d="M99.70361,348.91253c3.206,6.70666,5.20835,13.70047,4.9307,20.86031-.01231.31753-.02462.635-.05282.95187-.76057,14.69329-6.17341,31.68645-8.11534,44.04442-1.40908,8.86485-1.00808,15.33552,4.1797,16.85636,12.57723,3.66759-1.83379,6.28862,46.826,22.48494s57.15159,2.21623,57.27471-.95886-6.89116-27.29606-5.24206-28.822,23.07442,19.974,29.54772,17.04512.73874-19.05053.73874-19.05053-14.58264-33.954-14.27483-41.89176-22.08942-45.37466-22.08942-45.37466L178.193,235.89122s-5.85768-12.9466-13.73384-14.84195-14.411,2.621-14.411,2.621L163.228,252.80015l13.90546,51.417-2.32629,18.989s-16.17018-34.0156-26.7905-47.14689-33.26379-44.21805-33.26379-44.21805-5.28646-17.83738-1.2957-23.16791c3.99136-5.34632-16.64671-6.14663-25.4463,15.77118-4.66382,11.61641-12.23581,28.93924-16.97922,45.068-4.22682,14.28852-6.22343,27.646-2.03588,35.28111C75.396,316.45748,91.4958,331.78866,99.70361,348.91253Z"
          transform="translate(-50.625 -133.8148)"
          fill="#8d99ae"
        ></path>
        <path
          d="M68.99574,304.79359c6.40029,11.66389,22.50006,26.99507,30.70787,44.11894,2.14378-7.72349,4.75909-15.71476,4.75909-15.71476s10.03082-53.66869-19.64-67.53872a19.85762,19.85762,0,0,0-13.79106,3.85343C66.8048,283.801,64.80819,297.15851,68.99574,304.79359Z"
          transform="translate(-50.625 -133.8148)"
          opacity="0.1"
        ></path>
        <path
          d="M186.7818,301.41146l25.15446,7.33517,34.926,1.35436,3.593,30.348L193.05735,344.583S178.721,304.27874,186.7818,301.41146Z"
          transform="translate(-50.625 -133.8148)"
          fill="#8d99ae"
        ></path>
        <path
          d="M145.764,403.451s33.65163,5.58313,25.971,15.7098-37.49194-.51979-37.49194-.51979Z"
          transform="translate(-50.625 -133.8148)"
          fill="#ffb9b9"
        ></path>
        <path
          d="M104.58149,370.72471c-.76057,14.69329-6.17341,31.68645-8.11534,44.04442,10.72016,10.14608,20.91438,19.09523,24.75621,19.24421,7.93772.30781,20.69963-.78723,25.4007.985s7.4583-28.32955,7.4583-28.32955-2.80572-9.64839-15.32139-14.90351C130.31217,388.21008,114.119,378.56726,104.58149,370.72471Z"
          transform="translate(-50.625 -133.8148)"
          opacity="0.1"
        ></path>
        <path
          d="M85.19206,256.13379s-26.86513-4.22165-25.41378,40.35271-2.83185,73.027,7.97315,81.39568,45.90258,46.29809,53.8403,46.6059,20.69964-.78724,25.40071.985,7.45829-28.32954,7.45829-28.32954S151.645,387.49514,139.12935,382.24s-42.00182-23.88779-41.75558-30.238,7.4583-28.32955,7.4583-28.32955S114.8629,270.00382,85.19206,256.13379Z"
          transform="translate(-50.625 -133.8148)"
          fill="#8d99ae"
        ></path>
        <circle
          cx="100.65442"
          cy="58.10462"
          r="34.95222"
          fill="#ffb9b9"
        ></circle>
        <path
          d="M174.81363,141.82272a6.74905,6.74905,0,0,0,2.93882,1.47478,2.09716,2.09716,0,0,0,2.43029-1.68345c.79968,1.65841,1.70192,3.42593,3.33461,4.27689s4.15732.13741,4.39266-1.68864a7.706,7.706,0,0,0,1.77364,3.74392c1.013.96584,2.85,1.20961,3.73439.12482-.715,3.90745-.27369,7.92586-.49823,11.89184s-1.2821,8.17049-4.27847,10.7784c-4.36987,3.80334-10.94108,2.86467-16.68929,2.1441a5.06575,5.06575,0,0,0-2.61539.14307c-2.15231.917-2.05467,3.9131-2.08369,6.25243a17.37275,17.37275,0,0,1-15.21221,16.49749,8.70861,8.70861,0,0,1-6.47244-1.57964c-1.63206-1.38336-2.46572-3.63806-4.33585-4.67724-3.04207-1.6904-6.73153.77486-8.95568,3.45158s-4.4162,5.96933-7.86172,6.45932c-4.55691.648-8.02766-3.996-9.73047-8.27217a48.223,48.223,0,0,1,.95837-37.46978C125.15791,132.94937,157.66118,129.66876,174.81363,141.82272Z"
          transform="translate(-50.625 -133.8148)"
          fill="#000000"
        ></path>
        <path
          d="M1013.84731,697.58434c12.30975,20.99239,37.13647,29.30353,37.13647,29.30353s4.86866-25.72424-7.44108-46.71664-37.13647-29.30354-37.13647-29.30354S1001.53756,676.59194,1013.84731,697.58434Z"
          transform="translate(-50.625 -133.8148)"
          fill="#E6E6E6"
        ></path>
        <path
          d="M1021.52851,690.25752c21.28835,11.79052,30.20667,36.40565,30.20667,36.40565s-25.59693,5.49892-46.88529-6.2916-30.20667-36.40564-30.20667-36.40564S1000.24015,678.467,1021.52851,690.25752Z"
          transform="translate(-50.625 -133.8148)"
          fill="#fca311"
        ></path>
      </svg>
    </>
  );
}

export function FullStackDevSVGAlt() {
  return (
    <>
      <svg
        className="w-90%"
        viewBox="0 0 400 300"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Full Stack Development</title>
        <path d="m185.76 183.14h37.73v9.57h-37.73z" fill="#fff" />
        <path
          d="m113.64 145.2s-1.33 31.69 2.23 42.13h16.26a3.92 3.92 0 0 1 3.74 2.77l.88 2.91h-41.35a25.23 25.23 0 0 1 -7.66-7.93c-2.74-4.88-1.06-39.88-1.06-39.88z"
          fill="#fff"
        />
        <path
          d="m136.75 193.51h-41.35a.6.6 0 0 1 -.27-.07 25.62 25.62 0 0 1 -7.83-8.11c-2.81-5-1.19-38.72-1.12-40.15a.5.5 0 0 1 .5-.48h27a.48.48 0 0 1 .36.16.47.47 0 0 1 .14.37c0 .31-1.26 31 2.09 41.6h15.9a4.37 4.37 0 0 1 4.21 3.13l.88 2.91a.49.49 0 0 1 -.07.44.51.51 0 0 1 -.44.2zm-41.21-1h40.53l-.68-2.26a3.39 3.39 0 0 0 -3.26-2.42h-16.26a.49.49 0 0 1 -.47-.34c-3.35-9.79-2.44-37.49-2.28-41.79h-26c-.58 12.2-1.09 35.42 1 39.14a24.81 24.81 0 0 0 7.42 7.67z"
          fill="#231f20"
        />
        <path
          d="m88.66 179c0 6.6 2 8.58 4.62 8.58h10.38a3.49 3.49 0 0 1 3.27 2.29l1.15 3.13h-16c-4.09 0-7-6.21-7.13-12.81s0-35 0-35h3.57s.14 27.21.14 33.81z"
          fill="#231f20"
        />
        <path
          d="m108.08 193.51h-16c-4.61 0-7.5-6.76-7.63-13.3s0-34.72 0-35a.51.51 0 0 1 .5-.5h3.57a.51.51 0 0 1 .5.5c0 .27.13 27.28.13 33.81 0 8.08 3.1 8.08 4.12 8.08h10.38a4 4 0 0 1 3.74 2.62l1.15 3.13a.54.54 0 0 1 -.06.46.51.51 0 0 1 -.4.2zm-22.62-47.81c0 3.83-.12 28.44 0 34.49.14 6.79 3.11 12.32 6.63 12.32h15.27l-.9-2.46a3 3 0 0 0 -2.8-2h-10.38c-3.44 0-5.12-3-5.12-9.08s-.11-29.57-.13-33.31z"
          fill="#231f20"
        />
        <path
          d="m144.48 71.08 6.26 71.54a5.67 5.67 0 0 1 -5.6 6.4h-85.3a7 7 0 0 1 -6.72-6.4l-6.26-71.54a5.66 5.66 0 0 1 5.6-6.4h85.3a7 7 0 0 1 6.72 6.4z"
          fill="#231f20"
        />
        <path
          d="m145.14 149.52h-85.3a7.52 7.52 0 0 1 -7.22-6.86l-6.26-71.54a6.49 6.49 0 0 1 1.62-5 6 6 0 0 1 4.48-1.94h85.3a7.51 7.51 0 0 1 7.24 6.82l6.26 71.54a6.46 6.46 0 0 1 -1.63 5 6 6 0 0 1 -4.49 1.98zm-92.68-84.34a5 5 0 0 0 -3.74 1.61 5.49 5.49 0 0 0 -1.36 4.21l6.26 71.54a6.49 6.49 0 0 0 6.22 6h85.3a5 5 0 0 0 3.73-1.62 5.46 5.46 0 0 0 1.37-4.24l-6.24-71.56a6.48 6.48 0 0 0 -6.22-5.94z"
          fill="#231f20"
        />
        <path
          d="m144.77 70.79 6 68.3a5.41 5.41 0 0 1 -5.34 6.11h-81.43a6.69 6.69 0 0 1 -6.42-6.11l-6-68.3a5.4 5.4 0 0 1 5.34-6.11h81.45a6.69 6.69 0 0 1 6.4 6.11z"
          fill="#fff"
        />
        <path
          d="m145.4 145.7h-81.4a7.2 7.2 0 0 1 -7-6.56l-6-68.31a6.18 6.18 0 0 1 1.61-4.83 5.74 5.74 0 0 1 4.29-1.86h81.45a7.18 7.18 0 0 1 6.91 6.56l6 68.31a6.16 6.16 0 0 1 -1.56 4.79 5.73 5.73 0 0 1 -4.3 1.9zm-88.5-80.52a4.75 4.75 0 0 0 -3.55 1.53 5.23 5.23 0 0 0 -1.3 4l6 68.31a6.17 6.17 0 0 0 5.95 5.68h81.4a4.75 4.75 0 0 0 3.54-1.53 5.18 5.18 0 0 0 1.3-4l-6-68.31a6.18 6.18 0 0 0 -5.92-5.65z"
          fill="#231f20"
        />
        <path
          d="m149.74 127.62 1 11.47a5.41 5.41 0 0 1 -5.34 6.11h-81.4a6.69 6.69 0 0 1 -6.42-6.11l-1-11.47z"
          fill="#fff"
        />
        <path
          d="m145.4 145.7h-81.4a7.2 7.2 0 0 1 -7-6.56l-1-11.47a.52.52 0 0 1 .13-.38.48.48 0 0 1 .37-.17h93.21a.51.51 0 0 1 .5.46l1 11.47a6.16 6.16 0 0 1 -1.56 4.79 5.73 5.73 0 0 1 -4.25 1.86zm-88.33-17.58 1 10.93a6.17 6.17 0 0 0 5.93 5.65h81.4a4.75 4.75 0 0 0 3.54-1.53 5.18 5.18 0 0 0 1.3-4l-1-11z"
          fill="#231f20"
        />
        <ellipse
          cx="103.9"
          cy="136.41"
          fill="#fff"
          rx="3.7"
          ry="4.08"
          transform="matrix(.83069308 -.55673064 .55673064 .83069308 -58.36 80.95)"
        />
        <path
          d="m104.25 140.88a4.84 4.84 0 0 1 -4.65-4.42 4.18 4.18 0 0 1 1.06-3.25 3.88 3.88 0 0 1 2.9-1.26 4.83 4.83 0 0 1 4.64 4.42 4.19 4.19 0 0 1 -1 3.25 3.89 3.89 0 0 1 -2.95 1.26zm-.69-7.93a2.92 2.92 0 0 0 -2.17.93 3.23 3.23 0 0 0 -.79 2.49 3.82 3.82 0 0 0 3.65 3.51 2.87 2.87 0 0 0 2.16-.94 3.2 3.2 0 0 0 .8-2.48 3.82 3.82 0 0 0 -3.65-3.46z"
          fill="#231f20"
        />
        <path
          d="m58.08 69.24h79.92a3.48 3.48 0 0 1 3.33 3.18l4.21 48.18a2.81 2.81 0 0 1 -2.77 3.19h-79.92a3.49 3.49 0 0 1 -3.33-3.19l-4.21-48.18a2.81 2.81 0 0 1 2.77-3.18z"
          fill="#231f20"
        />
        <path
          d="m71.52 75.13h-7.94a.5.5 0 1 1 0-1h7.94a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m89.42 75.13h-15.85a.5.5 0 0 1 0-1h15.85a.5.5 0 1 1 0 1z"
          fill="#313638"
        />
        <path
          d="m95 78.24h-15.82a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h15.82a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m73.51 78.24h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m75.5 81.34h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m98 81.34h-19.85a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h19.85a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m77.49 84.45h-7.94a.5.5 0 0 1 0-1h7.94a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m102.21 84.45h-23.58a.5.5 0 0 1 0-1h23.58a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m75.51 87.56h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m89.92 87.56h-12.79a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h12.79a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m107.59 87.56h-12.78a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h12.78a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m75.64 90.67h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m90.05 90.67h-11.17a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h11.17a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m96.5 90.67h-4.57a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h4.57a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m75.76 93.77h-7.94a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m94.18 93.77h-16.31a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h16.31a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m104 93.77h-7.9a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.9a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m70.3 96.88h-4.22a.5.5 0 1 1 0-1h4.22a.5.5 0 1 1 0 1z"
          fill="#fff"
        />
        <path
          d="m92.18 96.88h-18.4a.5.5 0 0 1 0-1h18.4a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m74.15 100h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m83.35 103.09h-15.84a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h15.84a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m97 103.09h-11a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m112.21 103.09h-13.64a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h13.64a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m91.42 106.2h-23.1a.5.5 0 0 1 0-1h23.1a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m103.39 106.2h-10.39a.5.5 0 0 1 0-1h10.39a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m136.05 106.2h-30.9a.5.5 0 0 1 0-1h30.9a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m79.28 109.31h-10.92a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h10.92a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m89.5 109.31h-8a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m99.71 109.31h-8a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m87.79 112.42h-19.31a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h19.31a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m99.83 112.42h-9.65a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h9.65a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m116.91 112.42h-14.71a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h14.71a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m133.17 112.42h-14.71a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h14.71a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m85 115.52h-11.51a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h11.51a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m98.7 115.52h-11.52a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h11.52a.51.51 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m112.47 115.52h-11.47a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h11.52a.5.5 0 0 1 .5.5.5.5 0 0 1 -.55.5z"
          fill="#313638"
        />
        <path
          d="m126.75 115.87h-11.52a.5.5 0 0 1 0-1h11.52a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m83.27 118.63h-7.94a.5.5 0 1 1 0-1h7.94a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <g fill="#313638">
          <path d="m93.08 118.63h-7.94a.5.5 0 1 1 0-1h7.94a.5.5 0 0 1 0 1z" />
          <path d="m111.43 118.94-16.43-.31a.5.5 0 0 1 0-1l16.41.31a.5.5 0 0 1 .49.51.49.49 0 0 1 -.47.49z" />
          <path d="m116.15 84.45h-10.73a.5.5 0 0 1 0-1h10.73a.5.5 0 0 1 0 1z" />
          <path d="m124.07 84.48a36.43 36.43 0 0 1 -3.81 0 .49.49 0 0 1 -.33-.63.5.5 0 0 1 .56-.34h12.14a.5.5 0 0 1 0 1z" />
          <path d="m114.19 78.24h-15.59a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h15.59a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z" />
          <path d="m132.83 78.24h-15.51a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h15.51a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z" />
          <path d="m99.69 75.14c-3.16 0-5.36 0-5.46 0a.5.5 0 0 1 -.42-.57.51.51 0 0 1 .54-.42h17.92a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z" />
        </g>
        <path
          d="m116.52 75.13a.51.51 0 0 1 -.45-.29.49.49 0 0 1 .24-.66c.13-.06.32-.16 10.88-.05a.5.5 0 0 1 .5.5.52.52 0 0 1 -.51.5c-3.79 0-10-.08-10.54 0z"
          fill="#fff"
        />
        <path
          d="m102.34 96.88h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m84 100h-5.88a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h5.88a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m100.32 100h-14a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m130.35 100h-27.21a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h27.21a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m279.51 145.2s1.33 31.69-2.24 42.13h-16.27a3.9 3.9 0 0 0 -3.73 2.77l-.87 2.9h41.35a25.23 25.23 0 0 0 7.66-7.93c2.78-4.88 1.06-39.88 1.06-39.88z"
          fill="#fff"
        />
        <path
          d="m297.75 193.51h-41.35a.48.48 0 0 1 -.4-.2.53.53 0 0 1 -.08-.44l.88-2.91a4.38 4.38 0 0 1 4.21-3.13h15.9c3.36-10.56 2.11-41.29 2.1-41.6a.5.5 0 0 1 .13-.37.52.52 0 0 1 .37-.16h27a.51.51 0 0 1 .5.48c.07 1.43 1.69 35.2-1.12 40.15a25.6 25.6 0 0 1 -7.84 8.11.59.59 0 0 1 -.3.07zm-40.68-1h40.53a24.81 24.81 0 0 0 7.38-7.67c2.11-3.72 1.59-26.94 1-39.14h-25.98c.16 4.3 1.06 32-2.28 41.79a.5.5 0 0 1 -.48.34h-16.24a3.37 3.37 0 0 0 -3.25 2.42z"
          fill="#231f20"
        />
        <path
          d="m304.49 179c0 6.6-2 8.58-4.63 8.58h-10.37a3.49 3.49 0 0 0 -3.28 2.29l-1.14 3.13h16c4.1 0 7-6.21 7.14-12.81s0-35 0-35h-3.57s-.15 27.21-.15 33.81z"
          fill="#231f20"
        />
        <path
          d="m301.05 193.51h-16a.49.49 0 0 1 -.41-.21.48.48 0 0 1 -.06-.46l1.14-3.13a4 4 0 0 1 3.75-2.62h10.37c1 0 4.13 0 4.13-8.08 0-6.53.13-33.54.13-33.81a.5.5 0 0 1 .5-.5h3.57a.51.51 0 0 1 .5.5c0 .29.13 28.47 0 35s-3.01 13.31-7.62 13.31zm-15.27-1h15.27c3.52 0 6.5-5.53 6.64-12.32.12-6.05 0-30.66 0-34.49h-2.57c0 3.74-.13 27.27-.13 33.31s-1.68 9.08-5.13 9.08h-10.37a3 3 0 0 0 -2.81 2z"
          fill="#231f20"
        />
        <path
          d="m248.66 71.08-6.25 71.54a5.67 5.67 0 0 0 5.59 6.38h85.31a7 7 0 0 0 6.72-6.4l6.26-71.54a5.67 5.67 0 0 0 -5.6-6.4h-85.31a7 7 0 0 0 -6.72 6.42z"
          fill="#231f20"
        />
        <path
          d="m333.31 149.52h-85.31a6 6 0 0 1 -4.47-2 6.45 6.45 0 0 1 -1.62-5l6.26-71.52a7.5 7.5 0 0 1 7.21-6.85h85.31a6 6 0 0 1 4.47 1.94 6.41 6.41 0 0 1 1.62 5l-6.25 71.54a7.53 7.53 0 0 1 -7.22 6.89zm-77.93-84.34a6.49 6.49 0 0 0 -6.22 5.94l-6.26 71.54a5.5 5.5 0 0 0 1.37 4.24 5 5 0 0 0 3.73 1.62h85.31a6.5 6.5 0 0 0 6.22-6l6.26-71.52a5.49 5.49 0 0 0 -1.36-4.24 5 5 0 0 0 -3.74-1.61z"
          fill="#231f20"
        />
        <path
          d="m248.38 70.79-6 68.3a5.42 5.42 0 0 0 5.35 6.11h81.47a6.68 6.68 0 0 0 6.41-6.11l6-68.3a5.4 5.4 0 0 0 -5.34-6.11h-81.48a6.68 6.68 0 0 0 -6.41 6.11z"
          fill="#fff"
        />
        <path
          d="m329.2 145.7h-81.45a5.73 5.73 0 0 1 -4.28-1.86 6.16 6.16 0 0 1 -1.56-4.79l6-68.31a7.19 7.19 0 0 1 6.91-6.56h81.46a5.73 5.73 0 0 1 4.25 1.82 6.15 6.15 0 0 1 1.56 4.79l-6 68.31a7.19 7.19 0 0 1 -6.89 6.6zm-80.32-74.87-6 68.31a5.25 5.25 0 0 0 1.3 4 4.75 4.75 0 0 0 3.55 1.53h81.47a6.18 6.18 0 0 0 5.92-5.65l6-68.31a5.18 5.18 0 0 0 -1.29-4 4.75 4.75 0 0 0 -3.55-1.53h-81.49a6.17 6.17 0 0 0 -5.91 5.65z"
          fill="#231f20"
        />
        <path
          d="m243.41 127.62-1 11.47a5.42 5.42 0 0 0 5.35 6.11h81.44a6.68 6.68 0 0 0 6.41-6.11l1-11.47z"
          fill="#fff"
        />
        <path
          d="m329.2 145.7h-81.45a5.73 5.73 0 0 1 -4.28-1.86 6.16 6.16 0 0 1 -1.56-4.79l1-11.47a.5.5 0 0 1 .5-.46h93.21a.5.5 0 0 1 .37.17.52.52 0 0 1 .13.38l-1 11.47a7.19 7.19 0 0 1 -6.92 6.56zm-85.33-17.58-1 11a5.25 5.25 0 0 0 1.3 4 4.75 4.75 0 0 0 3.55 1.53h81.48a6.18 6.18 0 0 0 5.92-5.65l.95-10.93z"
          fill="#231f20"
        />
        <ellipse
          cx="289.24"
          cy="136.41"
          fill="#fff"
          rx="4.08"
          ry="3.7"
          transform="matrix(.55673064 -.83069308 .83069308 .55673064 14.89 300.73)"
        />
        <path
          d="m288.9 140.88a3.88 3.88 0 0 1 -2.9-1.26 4.18 4.18 0 0 1 -1.06-3.25 4.84 4.84 0 0 1 4.65-4.42 3.88 3.88 0 0 1 2.9 1.26 4.22 4.22 0 0 1 1.06 3.25 4.85 4.85 0 0 1 -4.65 4.42zm.69-7.93a3.82 3.82 0 0 0 -3.65 3.51 3.19 3.19 0 0 0 .79 2.48 2.9 2.9 0 0 0 2.17.94 3.83 3.83 0 0 0 3.65-3.51 3.2 3.2 0 0 0 -.8-2.48 2.87 2.87 0 0 0 -2.16-.89z"
          fill="#231f20"
        />
        <path
          d="m335.06 69.24h-79.88a3.46 3.46 0 0 0 -3.33 3.18l-4.22 48.18a2.82 2.82 0 0 0 2.78 3.19h79.88a3.47 3.47 0 0 0 3.33-3.19l4.22-48.18a2.81 2.81 0 0 0 -2.78-3.18z"
          fill="#231f20"
        />
        <path
          d="m268.54 75.13h-7.94a.5.5 0 0 1 0-1h7.94a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m286.43 75.13h-15.84a.5.5 0 0 1 0-1h15.84a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m291.34 78.24h-15.84a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h15.84a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m269.83 78.24h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m271.13 81.34h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.51.51 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m293.61 81.34h-19.84a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h19.84a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m272.42 84.45h-7.94a.5.5 0 0 1 0-1h7.94a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m297.14 84.45h-23.58a.5.5 0 0 1 0-1h23.58a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m269.75 87.56h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m284.16 87.56h-12.79a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h12.79a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m301.83 87.56h-12.83a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h12.79a.5.5 0 0 1 .5.5.51.51 0 0 1 -.46.5z"
          fill="#313638"
        />
        <path
          d="m269.18 90.67h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m283.59 90.67h-11.17a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h11.17a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m290 90.67h-4.57a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h4.57a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m268.61 93.77h-7.94a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.51.51 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m287 93.77h-16.29a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h16.29a.51.51 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m296.89 93.77h-7.89a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.94a.51.51 0 0 1 .5.5.5.5 0 0 1 -.55.5z"
          fill="#313638"
        />
        <path
          d="m262.45 96.88h-4.22a.5.5 0 0 1 0-1h4.22a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m284.33 96.88h-18.4a.5.5 0 0 1 0-1h18.4a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m265.61 100h-7.95a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h7.95a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m274.11 103.09h-15.84a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h15.84a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m287.76 103.09h-11a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m303 103.09h-13.66a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h13.66a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m281.49 106.2h-23.1a.5.5 0 0 1 0-1h23.1a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m293.45 106.2h-10.39a.5.5 0 0 1 0-1h10.39a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m326.11 106.2h-30.89a.5.5 0 0 1 0-1h30.89a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m268.65 109.31h-10.92a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h10.92a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m278.87 109.31h-8.05a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h8.05a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m289.08 109.31h-8.08a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h8.05a.5.5 0 0 1 .5.5.51.51 0 0 1 -.47.5z"
          fill="#313638"
        />
        <path
          d="m276.47 112.42h-19.31a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h19.31a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m288.51 112.42h-9.66a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h9.66a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m305.59 112.42h-14.71a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h14.71a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m321.84 112.42h-14.7a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h14.7a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m273 115.52h-11.53a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h11.53a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m286.68 115.52h-11.52a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h11.52a.51.51 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m300.45 115.52h-11.52a.5.5 0 0 1 -.5-.5.51.51 0 0 1 .5-.5h11.52a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m314.65 115.87h-11.52a.5.5 0 0 1 0-1h11.52a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m270.56 118.63h-7.94a.5.5 0 0 1 0-1h7.94a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m280.37 118.63h-7.95a.5.5 0 0 1 0-1h7.95a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m298.65 118.94-16.34-.31a.5.5 0 0 1 -.49-.51.47.47 0 0 1 .51-.49l16.34.31a.52.52 0 0 1 .49.51.5.5 0 0 1 -.51.49z"
          fill="#313638"
        />
        <path
          d="m311.08 84.45h-10.73a.5.5 0 0 1 0-1h10.73a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m319 84.48a28.69 28.69 0 0 1 -3.84-.06.5.5 0 0 1 .24-1h12.14a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m310.51 78.24h-15.59a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h15.59a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m329.15 78.24h-15.51a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h15.51a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m296.75 75.14c-3.18 0-5.41 0-5.51 0a.5.5 0 0 1 -.42-.57.51.51 0 0 1 .54-.42h17.93a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m313.54 75.13a.49.49 0 0 1 -.46-.3.5.5 0 0 1 .26-.66c.12 0 .34-.15 10.87 0a.5.5 0 0 1 0 1c-3.8 0-10-.08-10.55 0z"
          fill="#fff"
        />
        <path
          d="m294.49 96.88h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1z"
          fill="#313638"
        />
        <path
          d="m275.49 100h-5.91a.5.5 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h5.91a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path
          d="m291.78 100h-14a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5.51.51 0 0 1 -.5.5z"
          fill="#fff"
        />
        <path
          d="m321.81 100h-27.22a.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5h27.22a.5.5 0 0 1 .5.5.5.5 0 0 1 -.5.5z"
          fill="#313638"
        />
        <path d="m107.59 185.46h93.64v7.08h-93.64z" fill="#fff" />
        <path
          d="m201.23 193.05h-93.64a.51.51 0 0 1 -.5-.5v-7.09a.51.51 0 0 1 .5-.5h93.64a.5.5 0 0 1 .5.5v7.09a.5.5 0 0 1 -.5.5zm-93.14-1h92.64v-6.05h-92.64z"
          fill="#231f20"
        />
        <path d="m58.22 205.59h20.96v49.8h-20.96z" fill="#fff" />
        <path
          d="m79.17 255.89h-21a.5.5 0 0 1 -.5-.5v-49.8a.5.5 0 0 1 .5-.5h21a.5.5 0 0 1 .5.5v49.8a.5.5 0 0 1 -.5.5zm-20.45-1h20v-48.8h-20z"
          fill="#231f20"
        />
        <path d="m319.2 205.59h20.96v49.8h-20.96z" fill="#fff" />
        <path
          d="m340.15 255.89h-20.95a.5.5 0 0 1 -.5-.5v-49.8a.5.5 0 0 1 .5-.5h20.95a.5.5 0 0 1 .5.5v49.8a.5.5 0 0 1 -.5.5zm-20.45-1h19.95v-48.8h-19.95z"
          fill="#231f20"
        />
        <path d="m58.22 205.59h20.96v12.89h-20.96z" fill="#231f20" />
        <path
          d="m79.17 219h-21a.5.5 0 0 1 -.5-.5v-12.91a.5.5 0 0 1 .5-.5h21a.5.5 0 0 1 .5.5v12.89a.5.5 0 0 1 -.5.52zm-20.45-1h20v-11.91h-20z"
          fill="#231f20"
        />
        <path d="m319.2 205.59h20.96v12.89h-20.96z" fill="#231f20" />
        <path
          d="m340.15 219h-20.95a.5.5 0 0 1 -.5-.5v-12.91a.5.5 0 0 1 .5-.5h20.95a.5.5 0 0 1 .5.5v12.89a.5.5 0 0 1 -.5.52zm-20.45-1h19.95v-11.91h-19.95z"
          fill="#231f20"
        />
        <path d="m45.43 193.15h307.5v12.44h-307.5z" fill="#fff" />
        <path
          d="m352.93 206.09h-307.5a.51.51 0 0 1 -.5-.5v-12.44a.5.5 0 0 1 .5-.5h307.5a.5.5 0 0 1 .5.5v12.44a.5.5 0 0 1 -.5.5zm-307-1h306.5v-11.44h-306.5z"
          fill="#231f20"
        />
        <path
          d="m270.7 193.21h28.2c.51 0-3.25-12.13-12.31-12.47s-15.89 12.47-15.89 12.47z"
          fill="#231f20"
        />
        <path
          d="m298.9 193.71h-28.2a.49.49 0 0 1 -.44-.73c.29-.54 7.1-13.06 16.35-12.74 8.88.33 12.86 11.43 12.83 12.87a.55.55 0 0 1 -.54.6zm-27.33-1h26.83c-.47-2.22-4.37-11.19-11.82-11.47h-.34c-7.24-.01-13.09 8.83-14.67 11.47z"
          fill="#231f20"
        />
        <path
          d="m165 212.67s-45.11 10.82-46.48 18.8 2.17 23.58 2.17 23.58h116.2s5.52-32.86 0-45.34-71.89 2.96-71.89 2.96z"
          fill="#231f20"
        />
        <path
          d="m236.93 255.55h-116.2a.5.5 0 0 1 -.49-.39c-.14-.64-3.54-15.79-2.17-23.78 1.41-8.2 45-18.75 46.86-19.19.17 0 16.81-3.89 33.92-6.17 23.18-3.08 36.15-1.91 38.53 3.5 5.52 12.47.27 44.28 0 45.62a.5.5 0 0 1 -.45.41zm-115.8-1h115.37c.61-3.85 5-33.19 0-44.64-2.19-4.91-15.15-5.91-37.5-2.91-17 2.27-33.58 6.1-33.83 6.16-12.46 3-45 12.12-46.1 18.39-1.23 7.09 1.53 20.54 2.06 23z"
          fill="#231f20"
        />
        <path
          d="m243.24 159.59 8.35 19.18s23.55 4.3 25.22 3.39 4.17-4.1 5.75-5.12 8.06-.12 9.18.68 3.71 4 3.43 5-1.86-.11-1.86-.11 2.36 1.59 1.88 2.85-5.49-2.05-6.42-2.05-3.43 6.94-6.21 9.34-33.75 6.92-36.63 6.24-18.93-23.8-18.93-23.8l3.24-14.58z"
          fill="#fff"
        />
        <path
          d="m246.9 199.57a5.42 5.42 0 0 1 -1.08-.08c-3-.71-17.56-21.63-19.21-24a.52.52 0 0 1 -.08-.4l3.24-14.58a.51.51 0 0 1 .45-.39l13-1a.51.51 0 0 1 .5.3l8.24 18.94c11.14 2 23.49 3.89 24.63 3.39a17.1 17.1 0 0 0 3-2.67 18.87 18.87 0 0 1 2.69-2.43c1.8-1.18 8.54-.17 9.74.69 1 .72 4 4.13 3.62 5.55a1 1 0 0 1 -.56.7 2.16 2.16 0 0 1 .57 2.09.93.93 0 0 1 -.53.52c-.83.32-2.29-.35-4.42-1.4a13.47 13.47 0 0 0 -1.88-.84 17 17 0 0 0 -1.64 2.77c-1.19 2.24-2.67 5-4.31 6.44-1.85 1.59-13.57 3.6-18.52 4.39-6.69 1.03-14.41 2.01-17.45 2.01zm-19.35-24.48c6.18 8.89 16.55 23 18.5 23.42 3 .71 33.71-4 36.18-6.13 1.49-1.28 2.92-4 4.07-6.15 1.31-2.46 1.8-3.31 2.47-3.31a7.35 7.35 0 0 1 2.38 1c1 .51 3.18 1.57 3.62 1.37.18-.53-.84-1.57-1.65-2.15l-.12-.14a.5.5 0 0 1 .57-.82l.09.07a1.74 1.74 0 0 0 1 .38c.18-.66-2-3.63-3.22-4.52-.93-.67-7.21-1.59-8.62-.67a19.82 19.82 0 0 0 -2.52 2.29 17.53 17.53 0 0 1 -3.26 2.85c-1.74 1-21.59-2.61-25.55-3.34a.5.5 0 0 1 -.37-.29l-8.2-18.85-12.26 1z"
          fill="#231f20"
        />
        <path
          d="m146.25 161.07-6 14.69s-17.93-10.21-22.71-10.93c-13.56-2.06-18.57 6.6-18.8 8.08s13.1-.11 13.1-.11-5.62 2-5.12 4.44c.27 1.37 6.6-1.93 7.63-1.59s28.16 21.35 37.73 23.35 31.53-45.82 31.53-45.82"
          fill="#fff"
        />
        <path
          d="m152.65 199.58a3.08 3.08 0 0 1 -.68-.07c-7.54-1.61-25.3-14.43-33.83-20.6-2-1.43-3.71-2.67-4-2.8a12.86 12.86 0 0 0 -2.81.85c-2.44.88-4 1.38-4.71 1a.84.84 0 0 1 -.42-.58c-.31-1.54 1.16-2.83 2.66-3.72-4.1.41-9.56.76-10.43-.15a.71.71 0 0 1 -.21-.63c.21-1.4 5.22-10.65 19.36-8.51 4.43.67 19.41 9 22.4 10.72l5.77-14.17a.5.5 0 1 1 .93.37l-6 14.7a.52.52 0 0 1 -.3.28.49.49 0 0 1 -.41 0c-.18-.11-17.91-10.18-22.55-10.88-13.38-2-17.63 6.28-18.16 7.52 1.14.45 7.21.09 12.48-.54a.5.5 0 0 1 .55.39.49.49 0 0 1 -.32.58c-1.33.47-5 2.16-4.82 3.8.54.14 2.67-.63 3.83-1 1.91-.68 2.93-1 3.49-.85a42.81 42.81 0 0 1 4.22 2.93c7.81 5.65 26.12 18.86 33.45 20.44 7.54 1.6 24.92-32.33 31-45.54a.49.49 0 0 1 .66-.25.51.51 0 0 1 .25.66c-.87 1.81-21.29 46.05-31.4 46.05z"
          fill="#231f20"
        />
        <path
          d="m204.73 96a8.46 8.46 0 0 0 2.9-1.86 13.53 13.53 0 0 0 2.75-4.14 44.84 44.84 0 0 0 3.4-25.15c-.53-3.68-1.28-8.8-3.48-11.89a8.31 8.31 0 0 0 -4.16-2.9c-.45-.13-5.15.15-4.71.67a17.83 17.83 0 0 0 -14.2-6.11c-4.52.18-10 2.15-12.93 5.75-1.2 1.48-1.64 2.64-3.57 3.33a10.78 10.78 0 0 1 -7.78-.36c-.6-.25-4.5-1.62-4.48-2.16a13.48 13.48 0 0 0 7.61 12.55 18.79 18.79 0 0 1 -8.19-1.29 14.39 14.39 0 0 0 14.88 8.56c2 2.84 4.64 5.25 6.61 8.25 2.09 3.18 4.1 6.49 6.87 9.14 4.37 4.14 12.24 9.98 18.48 7.61z"
          fill="#fff"
        />
        <path
          d="m201.64 97.06c-6.24 0-12.87-5.6-15.73-8.34a43.38 43.38 0 0 1 -6.19-8.07l-.72-1.15a42.53 42.53 0 0 0 -3.6-4.5c-1-1.11-2-2.27-2.86-3.49a14.86 14.86 0 0 1 -15.12-8.87.5.5 0 0 1 .65-.65 18.45 18.45 0 0 0 6.14 1.28 14 14 0 0 1 -6.21-12.11.49.49 0 0 1 .52-.48.5.5 0 0 1 .48.32 17 17 0 0 0 3.59 1.6l.6.24a10.29 10.29 0 0 0 7.42.35 5.06 5.06 0 0 0 2.57-2.19c.22-.31.46-.63.74-1 3.13-3.86 8.93-5.76 13.29-5.94a18.61 18.61 0 0 1 14.27 5.94 16.54 16.54 0 0 1 4.8-.44 8.79 8.79 0 0 1 4.43 3.09c2.28 3.2 3 8.35 3.57 12.11a45.6 45.6 0 0 1 -3.45 25.43 14.18 14.18 0 0 1 -2.83 4.33 9.15 9.15 0 0 1 -3.08 2 9.15 9.15 0 0 1 -3.28.54zm-28.87-26.59a.51.51 0 0 1 .41.21c.9 1.27 2 2.48 3 3.66a44 44 0 0 1 3.62 4.66l.76 1.16a43.67 43.67 0 0 0 6 7.89c3.23 3.09 11.45 10 18 7.54a8.09 8.09 0 0 0 2.74-1.75 13.1 13.1 0 0 0 2.63-4 44.49 44.49 0 0 0 3.37-24.86c-.53-3.66-1.25-8.67-3.4-11.68a7.76 7.76 0 0 0 -3.9-2.76 18.07 18.07 0 0 0 -4.1.37.43.43 0 0 1 -.15.2.48.48 0 0 1 -.7-.06 17.31 17.31 0 0 0 -13.79-5.93c-4.13.17-9.62 2-12.56 5.57-.26.32-.49.63-.7.92a6 6 0 0 1 -3.09 2.56 11.36 11.36 0 0 1 -8.15-.37c-.1 0-.3-.12-.57-.22a30.47 30.47 0 0 1 -3.19-1.36 13 13 0 0 0 7.32 11.06.5.5 0 0 1 -.18 1 19.23 19.23 0 0 1 -7.26-.91 13.84 13.84 0 0 0 13.85 7.15z"
          fill="#231f20"
        />
        <path
          d="m172.31 81.44s-5.2 10.11-3.7 11.92 5.65 0 5.65 0"
          fill="#fff"
        />
        <path
          d="m170.8 94.68a3.21 3.21 0 0 1 -2.57-1c-1.63-2 2.74-10.73 3.64-12.47a.5.5 0 0 1 .89.46c-2.49 4.83-4.57 10.4-3.76 11.33 1 1.26 4 .36 5.06-.09a.5.5 0 0 1 .4.92 10.67 10.67 0 0 1 -3.66.85z"
          fill="#231f20"
        />
        <path
          d="m172.28 68.84c-3.61 3.67-1.71 10.39-1.19 14.84q1.09 9.38 2.63 18.7c.64 4 10.93 2.91 12.61 1.53l.11 15.85 21.91-3.71-3.53-19.8s-7 .81-11.89-6.83-6.24-25.28-6.24-25.28-10.88 1.12-14.41 4.7z"
          fill="#fff"
        />
        <path
          d="m186.44 120.26a.55.55 0 0 1 -.33-.12.5.5 0 0 1 -.17-.38l-.1-15c-2.22.89-7.25 1.36-10.16.26a3.36 3.36 0 0 1 -2.46-2.54c-1-6.19-1.9-12.49-2.63-18.73-.09-.74-.21-1.55-.34-2.4-.67-4.28-1.5-9.61 1.68-12.84 3.61-3.67 14.25-4.8 14.71-4.84a.48.48 0 0 1 .37.11.51.51 0 0 1 .17.35c0 .17 1.4 17.59 6.17 25 4.66 7.27 11.14 6.64 11.41 6.61a.51.51 0 0 1 .55.41l3.54 19.85a.52.52 0 0 1 -.09.38.46.46 0 0 1 -.32.2l-21.92 3.71zm-.11-16.85a.52.52 0 0 1 .21 0 .49.49 0 0 1 .29.45l.1 15.27 20.84-3.53-3.37-18.82c-1.68 0-7.56-.33-11.89-7.09-4.49-7-6-22-6.28-25-2.16.27-10.66 1.51-13.59 4.49s-2 7.93-1.41 12c.14.87.27 1.69.36 2.45.72 6.22 1.61 12.5 2.62 18.68.12.76.74 1.35 1.82 1.76 3.12 1.17 8.88.36 10-.54a.48.48 0 0 1 .3-.12z"
          fill="#231f20"
        />
        <path d="m173.36 97.7s5.17 2.46 7.21-2.85" fill="#fff" />
        <path
          d="m176 98.77a7.23 7.23 0 0 1 -2.88-.62.5.5 0 1 1 .43-.9 5.75 5.75 0 0 0 4.06.22 4.53 4.53 0 0 0 2.47-2.8.51.51 0 0 1 .65-.28.5.5 0 0 1 .27.61 5.56 5.56 0 0 1 -3 3.38 5.47 5.47 0 0 1 -2 .39z"
          fill="#231f20"
        />
        <path
          d="m184.76 84.14a8.47 8.47 0 0 1 1.24-4.48 12.09 12.09 0 0 1 2-3.09 4.11 4.11 0 0 1 3.26-1.4 3.84 3.84 0 0 1 2.67 1.67 7.37 7.37 0 0 1 1.12 3 13.53 13.53 0 0 1 -4.9 12.59l.31-.41"
          fill="#fff"
        />
        <path
          d="m190.15 93a.49.49 0 0 1 -.4-.79l.31-.42a.49.49 0 0 1 .4-.2 13.08 13.08 0 0 0 4.09-11.59 6.63 6.63 0 0 0 -1-2.82 3.36 3.36 0 0 0 -2.31-1.46 3.61 3.61 0 0 0 -2.85 1.24 11.56 11.56 0 0 0 -1.87 3 8.28 8.28 0 0 0 -1.24 4.22.49.49 0 0 1 -.45.54.51.51 0 0 1 -.54-.45 9 9 0 0 1 1.33-4.76 12.53 12.53 0 0 1 2-3.21 4.57 4.57 0 0 1 3.67-1.55 4.28 4.28 0 0 1 3 1.88 7.71 7.71 0 0 1 1.21 3.23 14.1 14.1 0 0 1 -5.08 13.07.5.5 0 0 1 -.27.07z"
          fill="#231f20"
        />
        <ellipse
          cx="173.62"
          cy="76.37"
          fill="#231f20"
          rx=".88"
          ry="2.25"
          transform="matrix(.99850822 -.05460164 .05460164 .99850822 -3.91 9.59)"
        />
        <path
          d="m186.33 103.91a26.17 26.17 0 0 0 10.24-3.18s-2.06 9.73-9.87 11z"
          fill="#231f20"
        />
        <path
          d="m186.7 112.2a.46.46 0 0 1 -.32-.11.47.47 0 0 1 -.18-.36l-.37-7.8a.5.5 0 0 1 .46-.52 26.11 26.11 0 0 0 10-3.11.5.5 0 0 1 .54 0 .49.49 0 0 1 .2.51c-.08.42-2.22 10.08-10.29 11.37zm.15-7.84.32 6.75c5.44-1.21 7.82-6.92 8.6-9.36a27.25 27.25 0 0 1 -8.92 2.61z"
          fill="#231f20"
        />
        <path
          d="m240.72 212.67s-1.08-73.2-12.06-90-39.41-20.67-53.05-10.67-10.61 100.67-10.61 100.67z"
          fill="#313638"
        />
        <path
          d="m185.1 107.7s-16.27 1.36-25.67 9.15-19.18 47.64-19.18 47.64l30 6.76z"
          fill="#313638"
        />
        <path
          d="m165.84 187.43a.52.52 0 0 1 -.49-.51c.35-21.5 1-57.66 1.26-58.28a.51.51 0 0 1 .67-.25.5.5 0 0 1 .27.59c-.22 1.52-.88 38.53-1.2 58a.5.5 0 0 1 -.51.45z"
          fill="#231f20"
        />
        <path
          d="m217.35 112.26s13.69 1.55 20.93 16.58c3.93 8.16 14 34.49 14 34.49l-30.21 3.48z"
          fill="#313638"
        />
        <path
          d="m244.25 192.55h-47.59a10.56 10.56 0 0 1 -10.47-11.93l5.22-40.05a10.55 10.55 0 0 1 10.47-9.2h47.59a10.56 10.56 0 0 1 10.47 11.92l-5.22 40.06a10.57 10.57 0 0 1 -10.47 9.2z"
          fill="#231f20"
        />
        <path
          d="m244.25 193.05h-47.59a11.06 11.06 0 0 1 -11-12.49l5.22-40.06a11.09 11.09 0 0 1 11-9.63h47.59a11.06 11.06 0 0 1 11 12.49l-5.23 40.06a11.08 11.08 0 0 1 -10.99 9.63zm-42.37-61.18a10.09 10.09 0 0 0 -10 8.76l-5.22 40.06a10.08 10.08 0 0 0 10 11.36h47.59a10.09 10.09 0 0 0 10-8.76l5.22-40.06a10 10 0 0 0 -10-11.36z"
          fill="#231f20"
        />
        <path
          d="m213.69 166.81s5.69 6.67 5.92 9.18-11.26 59.92-11.26 59.92l16.27-4.56s11.25-53.54 10.18-57.64-7.78-9.34-7.78-9.34z"
          fill="#231f20"
        />
        <path
          d="m208.35 236.41a.55.55 0 0 1 -.34-.13.54.54 0 0 1 -.15-.47c4.62-23.05 11.42-58 11.25-59.78s-4.25-7.07-5.8-8.9a.5.5 0 0 1 .29-.81l13.33-2.44a.49.49 0 0 1 .39.09c.28.22 6.87 5.4 8 9.61s-9.72 55.69-10.18 57.88a.49.49 0 0 1 -.35.38l-16.27 4.55a.34.34 0 0 1 -.17.02zm6.27-69.26c1.51 1.82 5.29 6.6 5.49 8.79.22 2.42-9.66 52-11.11 59.27l15.2-4.21c3.16-15.08 11-53.87 10.12-57.12-.92-3.53-6.39-8.09-7.44-8.94z"
          fill="#231f20"
        />
        <rect
          fill="#231f20"
          height="25.63"
          rx="6.76"
          width="96.36"
          x="152.08"
          y="229.42"
        />
        <path
          d="m241.67 255.55h-82.83a7.27 7.27 0 0 1 -7.26-7.26v-12.11a7.26 7.26 0 0 1 7.26-7.26h82.83a7.26 7.26 0 0 1 7.26 7.26v12.11a7.27 7.27 0 0 1 -7.26 7.26zm-82.83-25.63a6.26 6.26 0 0 0 -6.26 6.26v12.11a6.26 6.26 0 0 0 6.26 6.26h82.83a6.26 6.26 0 0 0 6.26-6.26v-12.11a6.26 6.26 0 0 0 -6.26-6.26z"
          fill="#231f20"
        />
        <path
          d="m152 249.74a.5.5 0 0 1 -.5-.5v-12.74a7.72 7.72 0 0 1 7.57-7.69l50.34-.81 8.92-45.95c0-.11 2.15-10.42-3.6-13.24a.49.49 0 0 1 -.23-.66.5.5 0 0 1 .67-.23c6.44 3.16 4.23 13.88 4.13 14.33l-9 46.33a.49.49 0 0 1 -.48.4l-50.74.82a6.73 6.73 0 0 0 -6.59 6.7v12.74a.5.5 0 0 1 -.49.5z"
          fill="#fff"
        />
        <path
          d="m241.85 229.92-16.79-.12a.47.47 0 0 1 -.38-.19.5.5 0 0 1 -.11-.41l3.38-16.63a.52.52 0 0 1 .59-.39.51.51 0 0 1 .39.59l-3.26 16 16.19.11a.5.5 0 0 1 0 1z"
          fill="#fff"
        />
        <path
          d="m234.8 175.85a.49.49 0 0 1 -.46-.53 8.43 8.43 0 0 0 -4-7.73.51.51 0 0 1 -.19-.68.5.5 0 0 1 .68-.19 9.43 9.43 0 0 1 4.51 8.67.5.5 0 0 1 -.54.46z"
          fill="#fff"
        />
        <path
          d="m76.47 185.88h-3.8a.5.5 0 0 1 0-1h3.8a3.44 3.44 0 1 0 0-6.87.51.51 0 0 1 -.5-.5.5.5 0 0 1 .5-.5 4.44 4.44 0 1 1 0 8.87z"
          fill="#d1d3d4"
        />
        <path
          d="m83.68 187.91c0 2.43-8.25 4.4-18.42 4.4s-18.43-2-18.43-4.4z"
          fill="#fff"
        />
        <path
          d="m65.26 192.81c-9.18 0-18.93-1.72-18.93-4.9a.5.5 0 0 1 .5-.5h36.85a.5.5 0 0 1 .5.5c0 3.18-9.75 4.9-18.92 4.9zm-17.73-4.4c1.2 1.56 7.72 3.4 17.73 3.4s16.53-1.81 17.74-3.4z"
          fill="#d1d3d4"
        />
        <path d="m74.7 187.91h-18.89l-3.61-14.09h26.11z" fill="#fff" />
        <path
          d="m74.7 188.41h-18.89a.49.49 0 0 1 -.48-.38l-3.61-14.09a.51.51 0 0 1 .09-.43.5.5 0 0 1 .4-.19h26.1a.51.51 0 0 1 .4.19.54.54 0 0 1 .09.43l-3.61 14.06a.51.51 0 0 1 -.49.41zm-18.5-1h18.12l3.35-13.09h-24.82z"
          fill="#d1d3d4"
        />
        <path
          d="m310.67 185.23h40.33v7.08h-40.33z"
          fill="#fff"
          transform="matrix(-1 0 0 -1 661.67 377.55)"
        />
        <path
          d="m351 192.82h-40.33a.5.5 0 0 1 -.5-.5v-7.09a.5.5 0 0 1 .5-.5h40.33a.51.51 0 0 1 .5.5v7.09a.51.51 0 0 1 -.5.5zm-39.83-1h39.33v-6.09h-39.33z"
          fill="#d1d3d4"
        />
        <path
          d="m316.31 178.15h46.26v7.08h-46.26z"
          fill="#fff"
          transform="matrix(-1 0 0 -1 678.87 363.38)"
        />
        <path
          d="m362.57 185.73h-46.26a.5.5 0 0 1 -.5-.5v-7.08a.5.5 0 0 1 .5-.5h46.26a.5.5 0 0 1 .5.5v7.08a.5.5 0 0 1 -.5.5zm-45.76-1h45.26v-6.08h-45.26z"
          fill="#d1d3d4"
        />
        <path
          d="m312.17 171.06h46.26v7.08h-46.26z"
          fill="#fff"
          transform="matrix(-1 0 0 -1 670.6 349.21)"
        />
        <path
          d="m358.43 178.65h-46.26a.5.5 0 0 1 -.5-.5v-7.09a.5.5 0 0 1 .5-.5h46.26a.5.5 0 0 1 .5.5v7.09a.5.5 0 0 1 -.5.5zm-45.76-1h45.26v-6.09h-45.26z"
          fill="#d1d3d4"
        />
        <path
          d="m335.3 185.23h21.19v7.08h-21.19z"
          fill="#231f20"
          transform="matrix(-1 0 0 -1 691.79 377.55)"
        />
        <path
          d="m356.49 192.82h-21.19a.5.5 0 0 1 -.5-.5v-7.09a.5.5 0 0 1 .5-.5h21.19a.5.5 0 0 1 .5.5v7.09a.5.5 0 0 1 -.5.5zm-20.69-1h20.2v-6.09h-20.2z"
          fill="#231f20"
        />
        <path
          d="m338.26 178.15h24.3v7.08h-24.3z"
          fill="#231f20"
          transform="matrix(-1 0 0 -1 700.83 363.38)"
        />
        <path
          d="m362.57 185.73h-24.31a.5.5 0 0 1 -.5-.5v-7.08a.5.5 0 0 1 .5-.5h24.31a.5.5 0 0 1 .5.5v7.08a.5.5 0 0 1 -.5.5zm-23.81-1h23.31v-6.08h-23.31z"
          fill="#231f20"
        />
        <path
          d="m336.09 171.06h24.3v7.08h-24.3z"
          fill="#231f20"
          transform="matrix(-1 0 0 -1 696.48 349.21)"
        />
        <path
          d="m360.39 178.65h-24.3a.5.5 0 0 1 -.5-.5v-7.09a.5.5 0 0 1 .5-.5h24.3a.5.5 0 0 1 .5.5v7.09a.5.5 0 0 1 -.5.5zm-23.8-1h23.3v-6.09h-23.3z"
          fill="#231f20"
        />
      </svg>
    </>
  );
}

export function Testing() {
  return (
    <>
      <svg
        class="2xl:w-37vw pl-55px sm:80vw md:w-70vw lg:w-65vw xl:w-35vw"
        id="a6dc9487-50e2-4fb9-af91-bf1b7118d463"
        data-name="Layer 1"
        height="450px"
        width="450px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1103.79 707.8"
      >
        <defs>
          <linearGradient
            id="bd43dd7f-2dfd-4389-bf1e-697a1c0f972b"
            x1="891.82"
            y1="790.72"
            x2="891.82"
            y2="522.9"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stop-color="gray" stop-opacity="0.25"></stop>
            <stop offset="0.54" stop-color="gray" stop-opacity="0.12"></stop>
            <stop offset="1" stop-color="gray" stop-opacity="0.1"></stop>
          </linearGradient>
        </defs>
        <title>The Mind Map</title>
        <ellipse
          cx="843.39"
          cy="664.8"
          rx="192"
          ry="43"
          fill="#313638"
          opacity="0.1"
        ></ellipse>
        <g opacity="0.1">
          <path
            d="M673.12,122.89c0,156.1,97.93,282.41,219,282.41"
            transform="translate(-48.1 -96.1)"
            fill="#313638"
          ></path>
        </g>
        <path
          d="M675.52,226.13c-70.75.54-138.73-15.45-203.73-33.27S342.32,155,273,146.82c-44.62-5.27-95.4-4.44-130.47,16-33.75,19.66-43.74,51.89-48.67,81.63-3.71,22.38-5.52,45.86,7.54,66.22C110.42,324.8,126,336.4,137,349.86c38.26,46.83,14.53,107.1-23.41,155.51-17.79,22.71-38.6,44.5-52.1,68.48s-19.18,51.1-5.79,74.6c13.28,23.28,43.54,40,76.09,51.45C197.92,723,275,727.6,350.05,729.06c166.14,3.25,332.71-6.63,498.83-16.5,61.47-3.66,123.22-7.34,183.48-17.15,33.46-5.45,67.92-13.44,91.74-30.61,30.25-21.8,36.68-57.11,15-82.33-36.37-42.29-133-49.68-159-95.53-14.31-25.24-1.57-54.37,17-78.92,39.94-52.64,108.35-100,110-158.62,1.1-40.25-34-79.28-86.68-96.43-55.25-18-130.79-12.79-169.85,21.61C810.34,210,738,225.66,675.52,226.13Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
          opacity="0.1"
        ></path>
        <path
          d="M995,127.29V645.7c0,15.42-14.88,28-33.24,28H258.34c-18.36,0-33.23-12.54-33.23-28V127.29c0-15.45,14.87-31.19,33.23-31.19l703.33,1.71C980,97.81,995,111.84,995,127.29Z"
          transform="translate(-48.1 -96.1)"
          fill="#fff"
        ></path>
        <path
          d="M995,127.45v24H225.11v-24A31.35,31.35,0,0,1,256.45,96.1H963.6A31.36,31.36,0,0,1,995,127.45Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <circle
          cx="214.3"
          cy="27.67"
          r="11.08"
          fill="#fa5959"
          opacity="0.8"
        ></circle>
        <circle
          cx="246.53"
          cy="27.67"
          r="11.08"
          fill="#fed253"
          opacity="0.8"
        ></circle>
        <circle
          cx="278.76"
          cy="27.67"
          r="11.08"
          fill="#8ccf4d"
          opacity="0.8"
        ></circle>
        <rect
          x="457"
          y="170.7"
          width="70.01"
          height="33.22"
          rx="8.57"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="598.84"
          y="170.7"
          width="70.01"
          height="33.22"
          rx="8.57"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <polyline
          points="491.81 203.17 561.89 294.68 634.08 202.74"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></polyline>
        <rect
          x="508.37"
          y="291.75"
          width="107.03"
          height="50.79"
          rx="8.57"
          opacity="0.1"
        ></rect>
        <rect
          x="510.55"
          y="292.79"
          width="102.68"
          height="48.73"
          rx="8.57"
          fill="#313638"
        ></rect>
        <line
          x1="492.29"
          y1="170.7"
          x2="491.38"
          y2="138.35"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <polyline
          points="675.22 139.93 634.08 170.7 590.81 139.93"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></polyline>
        <rect
          x="456.61"
          y="106.7"
          width="70.01"
          height="33.22"
          rx="8.57"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="640.21"
          y="106.7"
          width="70.01"
          height="33.22"
          rx="8.57"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="555.81"
          y="106.7"
          width="70.01"
          height="33.22"
          rx="8.57"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <line
          x1="561.89"
          y1="341.51"
          x2="561.62"
          y2="430.01"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <path
          d="M609.53,558.59v0Z"
          transform="translate(-48.1 -96.1)"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></path>
        <polyline
          points="462.42 493.11 561.42 462.48 660.82 492.89"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></polyline>
        <rect
          x="526.62"
          y="430.01"
          width="70.01"
          height="33.22"
          rx="8.57"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="861.88"
          y="345.12"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(1210.51 -631.25) rotate(90)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="861.88"
          y="454.76"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(377.41 1272.15) rotate(-90)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="625.82"
          y="492.66"
          width="70.01"
          height="33.22"
          rx="8.57"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="475.52"
          y="588.76"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(972.95 1114.65) rotate(-180)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="576.46"
          y="588.76"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(1174.83 1114.65) rotate(-180)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <line
          x1="801"
          y1="320.45"
          x2="832.16"
          y2="374.94"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <line
          x1="735.11"
          y1="319.78"
          x2="767.82"
          y2="319.78"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <line
          x1="613.23"
          y1="317.15"
          x2="702.51"
          y2="319.78"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <line
          x1="832.16"
          y1="265.63"
          x2="801.15"
          y2="320.21"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <rect
          x="732.22"
          y="399.07"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(1134.8 -447.65) rotate(90)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="797.48"
          y="399.94"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(1200.94 -512.04) rotate(90)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="288.1"
          y="345.12"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(636.73 -57.48) rotate(90)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="288.1"
          y="454.76"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(-196.37 698.37) rotate(-90)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <line
          x1="322.78"
          y1="320.45"
          x2="291.61"
          y2="374.94"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <line
          x1="388.66"
          y1="319.78"
          x2="355.96"
          y2="319.78"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <line
          x1="510.55"
          y1="317.15"
          x2="421.27"
          y2="319.78"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <line
          x1="291.61"
          y1="265.63"
          x2="322.62"
          y2="320.21"
          fill="none"
          stroke="#313638"
          stroke-miterlimit="10"
        ></line>
        <rect
          x="417.76"
          y="399.07"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(820.34 -133.18) rotate(90)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <rect
          x="352.49"
          y="399.94"
          width="70.01"
          height="33.22"
          rx="8.57"
          transform="translate(755.94 -67.05) rotate(90)"
          fill="#313638"
          opacity="0.2"
        ></rect>
        <path
          d="M156.12,598c0,50.24,31.52,90.9,70.47,90.9"
          transform="translate(-48.1 -96.1)"
          fill="#46455b"
        ></path>
        <path
          d="M226.59,688.89c0-50.81,35.18-91.92,78.65-91.92"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M181.66,602.55c0,47.72,20.1,86.34,44.93,86.34"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M226.59,688.89c0-64.92,40.66-117.45,90.9-117.45"
          transform="translate(-48.1 -96.1)"
          fill="#46455b"
        ></path>
        <ellipse
          cx="175.43"
          cy="607.19"
          rx="17.52"
          ry="2.96"
          fill="#313638"
          opacity="0.1"
        ></ellipse>
        <path
          d="M211.77,689.53s10-.31,13-2.45,15.37-4.71,16.12-1.27,15,17.11,3.73,17.2-26.22-1.76-29.22-3.59S211.77,689.53,211.77,689.53Z"
          transform="translate(-48.1 -96.1)"
          fill="#a8a8a8"
        ></path>
        <path
          d="M244.83,701.81c-11.28.09-26.21-1.75-29.22-3.59-2.29-1.39-3.2-6.39-3.51-8.7h-.33s.63,8.06,3.64,9.89,17.94,3.68,29.22,3.59c3.26,0,4.38-1.19,4.32-2.9C248.5,701.15,247.26,701.79,244.83,701.81Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.2"
        ></path>
        <path
          d="M1004.32,744.89l-27.67-40.12s-.52-9.93-2.33-12.26-.39-7.48-.39-7.48,1.94-2.84.26-3.09-.26-6.58-.26-6.58l-.13-10.07s1.55-9.67.26-12a3.82,3.82,0,0,1,.13-4.13s1.55-5.55,0-7-1.17-10.06-.78-16.89-2.71-10.71-2.71-11.74-10.22-11.1-10.22-12-6.46-4.64-10.34-5.68-5.82-1.8-5.69-2.32-6.08-2.58-6.08-2.58-5.43-.38-7.5-3.09-8.4-3.5-8.57-3.52c0-.18-.09-.36-.12-.54l-.12-.58c.49-.82.94-1.66,1.35-2.53l.36-.79a11,11,0,0,0,6.36-2,8.7,8.7,0,0,0,3.1-6.19,13.6,13.6,0,0,0-1.51-6.87c-1.14-2.33-2.8-4.73-2.23-7.25.25-1.09.9-2,1.24-3.11a8.19,8.19,0,0,0-.93-6.11c-1-1.87-2.34-3.52-3.43-5.34a20.73,20.73,0,0,1-2.73-7.54,11.88,11.88,0,0,0-1-4.11,7.62,7.62,0,0,0-2.27-2.29,22.65,22.65,0,0,0-13.9-4.21c-3.52.12-7,1.07-10.52.64a38.93,38.93,0,0,1-6.15-1.61c-4.33-1.28-9.34-1.81-13.11.67s-5.28,7.36-7.84,11.18c-2.27,3.38-5.58,6.21-7.3,9.79,0-.07,0-.14.05-.21a12.35,12.35,0,0,0-1,2.61c-.66,2.81-.11,5.75.57,8.55.36,1.45.84,3,2.09,3.82s3,.63,4.52.89c-.06.25-.12.49-.17.74a29.5,29.5,0,0,0,20.5,34.45c0,.26,0,.53,0,.78,0,.77-.06,1.51-.14,2.22h0s-13-2.67-16.49-.87-10.35,3.23-11.38,4.26-3.62.26-5.95,6.32-2.58,12.26-5.56,15.09-4.52,4.78-4.65,6.84.38,2.58-.78,3.23-2.84,3.35-2.33,4.38c0,0,.65,2.58-1.42,3.87a4.31,4.31,0,0,0-1.81,3.87s-.78,2.84-2.59,3.48-3,4.91-3,4.91l-5.86,6.74-11.63-12.86a4.9,4.9,0,0,0-6.91-.35L802,653.51a11.24,11.24,0,0,0-5.71,3.4,15,15,0,0,0-3,4.4l-3.12,2.82a4.8,4.8,0,0,0-1.61,3.44,4.85,4.85,0,0,0,.81,5.32l7.44,8.24,0,.07a13,13,0,0,0-7.2,2.93c-11.12,9.8-11.25,18.83-9.57,23s15.77,20,15.77,20,8.19,10.65,20,16.31h0l-.08.09c-.24.25-.47.52-.7.81l-.19.25-.18.25-.21.31-.16.25-.23.37a2,2,0,0,1-.14.25c-.09.16-.18.33-.26.5l-.09.17c-.11.22-.21.46-.32.7s-.07.18-.1.26-.14.34-.2.52l-.12.33c-.06.16-.11.33-.17.5s-.07.24-.11.37l-.15.56-.09.35c-.08.3-.14.61-.21.93l-.06.37c0,.21-.08.43-.11.66s-.05.31-.07.47,0,.42-.08.64,0,.33-.05.49,0,.49,0,.74,0,.29,0,.45c0,.4,0,.82-.05,1.25-.26,15.09.62,17.28.62,17.28s1.83,4.81,6.87,5.15a8.93,8.93,0,0,0,2.21-.12c6.72-1.16,22.5-3.87,28.06-2.83,3.34.62,9.53-.3,13.93-1.13l1.17-.23.8,2.57,2.56-.7,2.17,1.25,1.37.79c2.55,8.65,12.91,5.7,12.91,5.7l2.46,1.42,25,.64a50.53,50.53,0,0,0,8.84,4.25,8.88,8.88,0,0,0,1.25.27,57.46,57.46,0,0,0,6.95.13c1.92,0,3.4-.13,3.4-.13s-.26-6.77-.62-14.36c9.53-.4,18-1,23.11-1.89C968,772,973.55,759.84,975.6,753.36a60.65,60.65,0,0,1,1.3,8,58.61,58.61,0,0,0,2.07,7,23.67,23.67,0,0,0,2.85,5.16c9.83-3.35,3.88-8.38,1.81-10.57s1.42-4,1.42-4,2.72-1.81,2.46-3.49-.39-3.48,8.4-3.35S1004.32,744.89,1004.32,744.89ZM867.78,662.52c.11.74,1.34,8.68,2.45,10.77a14.37,14.37,0,0,1,.29,4.25c-5.21-.41-10.64-.64-10.64-.64a1.24,1.24,0,0,1,.28.67l-.82-.19c-.38-.09-.78-.18-1.19-.29l9.6-14.59Zm-19,30.25,9,1.43.76.12a30.29,30.29,0,0,0-.47,4.26c0,.13.2.29.49.48a11.67,11.67,0,0,0-.17,2.13c.14.72,4.36,2.26,9.2,3.54-.07.26-.14.5-.2.74h0c-4.27-2.25-11-3.3-11.78-5S832,690.84,832,690.84s-.84-.45-2.28-1.14l6,1.14,1.66-.17A89.92,89.92,0,0,0,848.76,692.77Z"
          transform="translate(-48.1 -96.1)"
          fill="url(#bd43dd7f-2dfd-4389-bf1e-697a1c0f972b)"
        ></path>
        <path
          d="M974.89,750.5s-3.59,21.65-21.79,24.86-78.94,2.56-78.94,2.56-34.73-5-47.29-34.34-20.63-41-9.87-41.53,68.82,19.61,72.15,19.87S978.09,677.32,974.89,750.5Z"
          transform="translate(-48.1 -96.1)"
          fill="#65617d"
        ></path>
        <path
          d="M974.89,750.5s-3.59,21.65-21.79,24.86-78.94,2.56-78.94,2.56-34.73-5-47.29-34.34-20.63-41-9.87-41.53,68.82,19.61,72.15,19.87S978.09,677.32,974.89,750.5Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.05"
        ></path>
        <path
          d="M812,774.59s1.81,4.77,6.8,5.12a8.77,8.77,0,0,0,2.19-.12c6.67-1.16,22.3-3.85,27.81-2.82,3.32.61,9.45-.3,13.82-1.12,2.9-.55,5-1.06,5-1.06s-5.12-17-5.77-17.56-23.06-14-23.06-14L821,741.79H821a9.39,9.39,0,0,0-6,3.54c-1.87,2.27-3.48,6-3.59,12.1C811.1,772.41,812,774.59,812,774.59Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M812,774.59s1.81,4.77,6.8,5.12a73.93,73.93,0,0,1-4.82-7l.09-12.43a21.89,21.89,0,0,1,7-18.45H821s-9.35.64-9.61,15.64S812,774.59,812,774.59Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.05"
        ></path>
        <path
          d="M889,747.42l16.53-12.94,26-25.63s-2.81-.14-7.05-.32c-1,.67-4,2.78-4.12,5.35-.12,3.14-7,.22-10.62,2S888.64,740.16,885.56,740s-5.51-1.56-6.79.62l-.09.14Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M815,745.32c.59.28,1.19.56,1.79.82,12.56,5.38,28.07,16.66,29.22,18.71.71,1.25,9.7,6.71,16.64,10.8,2.9-.55,5-1.06,5-1.06s-5.12-17-5.77-17.56-23.06-14-23.06-14L821,741.79H821A9.39,9.39,0,0,0,815,745.32Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M780.09,708.59c1.67,4.1,15.64,19.86,15.64,19.86s8.84,11.54,21.4,16.92,28.06,16.66,29.22,18.71c.74,1.32,10.75,7.35,17.8,11.49l1.58.92,3.5,2,1.85,1.07s4.29-3.45,8.57-6.92,8.41-6.86,8.48-7c.12-.38,1.79-4.74,1.4-5-.2-.13-1.08-1.91-2.69-4a18.25,18.25,0,0,0-6.53-5.4c-5.9-2.69-8.46-8.82-8.46-8.82s-.56-.4-1.41-.94a17.09,17.09,0,0,0-5.77-2.57c-2.82-.35-8.07-6.12-8.07-6.12s-3.59-2.31-5-5.25-21.22-16.46-23.06-17.73l48.18,30.95,11.53,7.41,16.54-12.94,26-25.63s-3.5-.17-8.58-.39c-12.65-.55-35.1-1.41-37.94-.77a21.45,21.45,0,0,1-7,.46s-6.4.29-10.63-1.94-10.9-3.28-11.67-4.93-23.45-9.61-23.45-9.61-30.88-16.4-41.91-6.66S778.43,704.49,780.09,708.59Z"
          transform="translate(-48.1 -96.1)"
          fill="#65617d"
        ></path>
        <path
          d="M879.67,614.53l4,13.19,5.13,29.74,18.83,1.28,5.46-9,5.44-9s3.39-12,5.83-23.64c2.15-10.28,3.56-20.26,1.22-21.34-2.08-1-3.45-4.43-4.34-8.15-.11-.46-.22-.93-.31-1.39a73.86,73.86,0,0,1-1.25-9.56s-39.47-2.05-34,14.23a25.82,25.82,0,0,1,1.49,8.65,21.8,21.8,0,0,1-.14,2.2A18.45,18.45,0,0,1,879.67,614.53Z"
          transform="translate(-48.1 -96.1)"
          fill="#ee8e9e"
        ></path>
        <path
          d="M871.46,612.35l1.42,22.42,3.2,19.1,3.59,8.84,3.2,48.38s30.9,3.57,38.42-.06a3.33,3.33,0,0,0,1.36-1.07c9.07-13.7,6.1-53.4,6.1-53.4l3.46-25.63-2.31-13.3-5.57-.6-4.29-.45s-1,1.19-2.37,3c-3.8,5-10.79,14.88-10.32,19,.64,5.64-.77,11.4-3,12.3s-4,2.44-4.35.9-.77-1.92-.39-4.1-1.67-8.85-1.67-8.85-3.46-7.81-3.2-11.15-.38-7.17-1.41-8.07-2.43-1.79-1.28-5.89S887,601.67,887,601.67Z"
          transform="translate(-48.1 -96.1)"
          fill="#e3e8f4"
        ></path>
        <path
          d="M912.28,668.36l1.29,38.32,7.4,4.1a3.4,3.4,0,0,0,1.36-1.06c9.07-13.71,6.1-53.41,6.1-53.41l3.46-25.63-2.31-13.3-5.57-.6c2.15-10.28,3.56-20.26,1.22-21.34-2.08-1-3.45-4.43-4.34-8.15h0l-4,27.11s.33,2.45.45,5a14.26,14.26,0,0,1-.32,4.77c-.9,2.31-.26,6.41-.26,6.41-2.31,4.07-3.47,11.61-4,18.89C912,659.13,912.28,668.36,912.28,668.36Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M921,586.68s6.46.8,8.51,3.5,7.43,3.07,7.43,3.07,6.15,2,6,2.56,1.79,1.29,5.63,2.31,10.26,4.74,10.26,5.64S969,614.65,969,615.68s3.08,4.87,2.69,11.66-.77,15.38.77,16.79,0,6.92,0,6.92a3.78,3.78,0,0,0-.13,4.1c1.28,2.31-.25,11.92-.25,11.92l.12,10s-1.41,6.28.26,6.54-.26,3.08-.26,3.08-1.41,5.12.39,7.43,2.31,12.17,2.31,12.17l27.42,39.86s.39,7.3-8.33,7.18-8.59,1.66-8.33,3.33-2.43,3.46-2.43,3.46-3.46,1.79-1.41,4,7.94,7.18-1.8,10.51a23.76,23.76,0,0,1-2.82-5.13,58,58,0,0,1-2.05-6.92s-.9-9.74-2.69-11-1.54-7.43-1.54-7.43,2.57-5-1-7.05-55.62-30.89-55.62-30.89L913,667.84s-.9-28.32,4.48-37.81c0,0-.64-4.1.26-6.41s-.13-9.74-.13-9.74Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M887.43,602.06s-12.89-2.66-16.35-.86-10.25,3.2-11.28,4.23-3.58.25-5.89,6.28-2.56,12.17-5.51,15-4.49,4.74-4.62,6.79.39,2.56-.76,3.21-2.82,3.33-2.31,4.35,26.65,23.58,26.65,23.58,1.29,8.59,2.44,10.77-1.28,32.16-3.84,34.22,17.3,1.86,17.3,1.86.89-19.68,1.66-20.7-.51-22-.51-22-.13-17.94,1.54-22.68,1.48-20.5,1.48-20.5,1.47-9.46,3.26-11.67S887.43,602.06,887.43,602.06Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M887,601.67s-12.88-2.65-16.34-.86S860.44,604,859.42,605s-3.59.26-5.9,6.28-2.56,12.18-5.51,15-4.48,4.74-4.61,6.79.38,2.56-.77,3.2-2.82,3.33-2.31,4.36S867,664.25,867,664.25s1.28,8.58,2.44,10.76-1.29,32.17-3.85,34.22,17.3,1.86,17.3,1.86.9-19.67,1.67-20.7-.52-22-.52-22-.12-17.94,1.54-22.68S887,625.16,887,625.16s1.47-9.46,3.26-11.66S887,601.67,887,601.67Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M885.69,590.82a25.82,25.82,0,0,1,1.49,8.65,29.36,29.36,0,0,0,33.72-13.32,73.86,73.86,0,0,1-1.25-9.56S880.18,574.54,885.69,590.82Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M866.21,570.57a29.35,29.35,0,1,0,.64-6.1A29.35,29.35,0,0,0,866.21,570.57Z"
          transform="translate(-48.1 -96.1)"
          fill="#ee8e9e"
        ></path>
        <path
          d="M847.37,638.49l-7,2.18s.65,2.56-1.41,3.84a4.29,4.29,0,0,0-1.79,3.85s-.77,2.82-2.56,3.46-2.95,4.87-2.95,4.87l-5.9,6.79s-2.17,1.79-1.79,2.69-2.31,1.15-2.31,1.15L823,690.14l12.18,2.3,7.56-.77,6.15-2.3,5.38-3.21,2.44-6.28,10.76-16.4Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M823.41,669.12s-15.64-22.56-27.3-10.38,4.74,31.91,8.59,31.27,22.17-1.67,22.17-1.67Z"
          transform="translate(-48.1 -96.1)"
          fill="#ee8e9e"
        ></path>
        <rect
          x="770.4"
          y="638.26"
          width="81.83"
          height="63.54"
          rx="1.54"
          transform="translate(345.12 -391.66) rotate(27.04)"
          fill="#313638"
        ></rect>
        <rect
          x="777.03"
          y="644.03"
          width="68.78"
          height="51.83"
          transform="translate(345.09 -391.72) rotate(27.04)"
          fill="#313638"
        ></rect>
        <circle cx="730.3" cy="557" r="1.13" fill="#e6e8ec"></circle>
        <circle cx="796.61" cy="590.97" r="1.86" fill="#e6e8ec"></circle>
        <path
          d="M813.28,673.86c-.12,16.92,34.86,20.5,34.86,20.5l8.94,1.42,4,.64,1.67-16.54s-1.83-.27-4.12-.8c-3.39-.79-7.78-2.16-8.7-4.07C848.4,671.81,813.41,656.94,813.28,673.86Z"
          transform="translate(-48.1 -96.1)"
          fill="#ee8e9e"
        ></path>
        <path
          d="M866.85,564.47a3.41,3.41,0,0,1,2.15,1c1,1.05,1,2.91,2.33,3.55a2.58,2.58,0,0,0,1.53.18c3.41-.48,5.38-4.33,8.65-5.39a8.67,8.67,0,0,1,5.73.5,4.18,4.18,0,0,1,1.9,1.21c1.1,1.42.33,3.51.84,5.22.7,2.38,3.54,3.33,6,3.64s5.23.48,6.88,2.34a6.27,6.27,0,0,1,1.22,5,3.91,3.91,0,0,0,0,1.83c.68,1.93,4,1.64,4.87.12.64-1.1.45-2,1.94-2.32a6.32,6.32,0,0,1,3.14.54,23.08,23.08,0,0,0,8.11,1.24,29.35,29.35,0,1,0-55.27-18.58Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M904.06,582.71a4,4,0,0,1,0-1.84,6.27,6.27,0,0,0-1.22-5c-1.65-1.86-4.42-2-6.88-2.34s-5.3-1.26-6-3.64c-.51-1.71.26-3.8-.84-5.21a4.14,4.14,0,0,0-1.9-1.22,8.67,8.67,0,0,0-5.73-.5c-3.27,1.06-5.24,4.91-8.65,5.39a2.58,2.58,0,0,1-1.53-.18c-1.29-.64-1.34-2.5-2.33-3.55-1.56-1.65-4.51-.58-6.42-1.81-1.24-.8-1.72-2.36-2.07-3.79-.67-2.79-1.22-5.71-.56-8.5,1.11-4.77,5.37-8,8.09-12.11,2.54-3.79,4-8.59,7.77-11.11s8.7-1.94,13-.66a37.88,37.88,0,0,0,6.09,1.59c3.46.43,6.94-.51,10.43-.63a22.46,22.46,0,0,1,13.77,4.18,7.64,7.64,0,0,1,2.25,2.28,11.49,11.49,0,0,1,1,4.08,20.82,20.82,0,0,0,2.71,7.5c1.07,1.8,2.43,3.43,3.4,5.3a8.18,8.18,0,0,1,.92,6.07c-.33,1.05-1,2-1.23,3.09-.57,2.5,1.08,4.89,2.21,7.2a13.55,13.55,0,0,1,1.5,6.83,8.61,8.61,0,0,1-3.08,6.14,11,11,0,0,1-6.49,2A23,23,0,0,1,914,581a6.32,6.32,0,0,0-3.14-.54c-1.49.3-1.3,1.22-1.94,2.32C908.06,584.34,904.74,584.63,904.06,582.71Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M888.25,748.19l16.54-12.94,26-25.63s-3.5-.17-8.58-.39a5.63,5.63,0,0,0-1.82,3.5c-.12,3.13-7,.22-10.62,2S888.64,739,885.56,738.86s-5.51-1.56-6.79.62l-.09.14a3.68,3.68,0,0,1-2,1.16Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M854.93,747.29l8.31,26.52,1.3,4.16,4-1.08,8.72-2.4,38.84-10.67a33.62,33.62,0,0,0,14-3.73,42.44,42.44,0,0,1,24.14-5.26c5.13.48,10.84-1.73,15.58-10.49,0,0,10.76-31.78-16.41-40.88s-28.46,4.84-28.46,4.84l-.37.23c-1,.67-4,2.78-4.12,5.35-.12,3.14-7,.22-10.62,2S888.64,740.16,885.56,740s-5.51-1.56-6.79.62l-.09.14c-.95,1.31-3.81,1.61-5.69,1.67-1,0-1.78,0-1.78,0l-.24.07-2,.59Z"
          transform="translate(-48.1 -96.1)"
          fill="#65617d"
        ></path>
        <path
          d="M857.08,695.78l4,.64,1.67-16.54s-1.83-.27-4.12-.8C859.23,681.38,857.86,690.3,857.08,695.78Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M961.87,618.53s11.92-3.46,9,30.38-25,55.23-25,55.23-25.37,11.15-36.78,9.36a198.28,198.28,0,0,0-19.73-2.18,29,29,0,0,0-11.54-3.08c-6.4-.25-19.86-4.23-20.12-5.51s3.34-20.12,1.8-21.53c0,0,17.94.74,19.73,2s4.36.37,6.28,0,7.82-5.49,19.48-1c0,0,4,.38,5.51-.64s4-.26,4-.26a11.49,11.49,0,0,0,2.79-1.41c.38-.51,3.46,0,3.46,0a1.36,1.36,0,0,0,1.92-.9,8.34,8.34,0,0,1,1.79-2.82s3.46-19.48,10-26.78c0,0,1.92-1.67,1.41-3.72S946.49,614.43,961.87,618.53Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M961.56,615.93s11.92-3.46,9,30.38-25,55.23-25,55.23-25.38,11.15-36.78,9.36S889,708.72,889,708.72a29,29,0,0,0-11.53-3.08c-6.41-.25-19.86-4.23-20.12-5.51s3.33-20.12,1.79-21.53c0,0,17.94.74,19.74,2s4.36.36,6.28,0,7.82-5.5,19.48-1c0,0,4,.38,5.51-.64s4-.26,4-.26a11.29,11.29,0,0,0,2.78-1.41c.38-.51,3.46,0,3.46,0a1.36,1.36,0,0,0,1.92-.9,8.59,8.59,0,0,1,1.8-2.82s3.46-19.48,10-26.78c0,0,1.93-1.67,1.41-3.72S946.18,611.83,961.56,615.93Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M869,743.08l16.92,20.48c.07-.06.11-.1.11-.12.13-.38,1.79-4.74,1.41-5s-3.33-6.67-9.23-9.36a17.49,17.49,0,0,1-7.24-6.6Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M869.23,778.52l1.85,1.07s4.29-3.45,8.57-6.92,8.41-6.86,8.48-7c.12-.38,1.79-4.74,1.4-5-.2-.13-1.08-1.91-2.69-4-11.48-3.22-4.17,4.75-3.2,5.11,0,0-14-3.2-14.74,12A18,18,0,0,0,869.23,778.52Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M883.38,785l2.44,1.41,24.73.64a50,50,0,0,0,8.76,4.21,7.66,7.66,0,0,0,1.24.28,58.55,58.55,0,0,0,6.89.13c1.9,0,3.36-.13,3.36-.13s-1.17-31.2-2-34.48c-.42-1.57-2.5-1.22-4.54-.44a30,30,0,0,0-4.43,2.24s-10.51,1-12.18,1.93-6.4-.52-9.35,0-8.2-3.47-8.2-3.47c-14.36-4.74-6.28,4.1-5.26,4.48,0,0-14-3.2-14.73,12S883.38,785,883.38,785Z"
          transform="translate(-48.1 -96.1)"
          fill="#313638"
        ></path>
        <path
          d="M919.14,772.92c.27,6.46,5.3,14.48,8.3,18.72,1.9,0,3.36-.13,3.36-.13s-1.17-31.2-2-34.48c-.42-1.57-2.5-1.22-4.54-.44C921.73,761.24,918.92,767.72,919.14,772.92Z"
          transform="translate(-48.1 -96.1)"
          fill="#565387"
        ></path>
        <path
          d="M919.14,772.92c.27,6.46,5.3,14.48,8.3,18.72,1.9,0,3.36-.13,3.36-.13s-1.17-31.2-2-34.48c-.42-1.57-2.5-1.22-4.54-.44C921.73,761.24,918.92,767.72,919.14,772.92Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <path
          d="M914.91,773.78c1.7,6.23,1.68,13.22,4.4,17.45a7.66,7.66,0,0,0,1.24.28,58.55,58.55,0,0,0,6.89.13c1.9,0,3.36-.13,3.36-.13s-1.17-31.2-2-34.48c-.42-1.57-2.5-1.22-4.54-.44a30,30,0,0,0-4.43,2.24S912.73,765.8,914.91,773.78Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.05"
        ></path>
        <path
          d="M829.58,710.55s12.29,4,22.7,18.16Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
        <g opacity="0.1">
          <path
            d="M929.41,556.77c0,.1,0,.19-.07.28a10.86,10.86,0,0,1-.43,1.07A8.1,8.1,0,0,1,929.41,556.77Z"
            transform="translate(-48.1 -96.1)"
          ></path>
          <path
            d="M859.9,550.56a12,12,0,0,1,1-2.59c-.07.22-.13.44-.19.67-.65,2.79-.11,5.71.57,8.49.35,1.44.83,3,2.07,3.8,1.91,1.22,4.86.16,6.42,1.81,1,1,1,2.91,2.33,3.55a2.58,2.58,0,0,0,1.53.18c3.4-.48,5.38-4.33,8.65-5.39a8.67,8.67,0,0,1,5.73.5,4.17,4.17,0,0,1,1.9,1.22c1.09,1.41.33,3.5.83,5.21.71,2.38,3.55,3.32,6,3.64s5.23.48,6.88,2.34a6.27,6.27,0,0,1,1.22,5,3.78,3.78,0,0,0,0,1.83c.68,1.92,4,1.64,4.87.12.64-1.1.44-2,1.94-2.33a6.44,6.44,0,0,1,3.14.55,23.26,23.26,0,0,0,8.28,1.24,11,11,0,0,0,6.49-2,7.54,7.54,0,0,0,2-2.42,8.21,8.21,0,0,1-2.77,4.34,11,11,0,0,1-6.49,2A23,23,0,0,1,914,581a6.32,6.32,0,0,0-3.14-.54c-1.49.3-1.3,1.22-1.94,2.32-.87,1.52-4.19,1.81-4.87-.11a4,4,0,0,1,0-1.84,6.27,6.27,0,0,0-1.22-5c-1.65-1.86-4.42-2-6.88-2.34s-5.3-1.26-6-3.64c-.51-1.71.26-3.8-.84-5.21a4.19,4.19,0,0,0-1.9-1.22,8.67,8.67,0,0,0-5.73-.5c-3.27,1.06-5.25,4.91-8.65,5.39a2.58,2.58,0,0,1-1.53-.18c-1.29-.64-1.34-2.5-2.33-3.55-1.56-1.65-4.51-.58-6.42-1.81-1.24-.8-1.72-2.36-2.07-3.79C859.79,556.27,859.25,553.35,859.9,550.56Z"
            transform="translate(-48.1 -96.1)"
          ></path>
        </g>
        <path
          d="M931.4,653.13c-2.35,3.17-5,6.1-7.11,9.45s-3.54,7.27-3.11,11.19c2.15-2.2,3.13-5.25,4.49-8,2.29-4.68,5.72-8.65,8.62-13,.55-.82,4.09-5.57,2.3-5.8C935.11,646.8,932.2,652.05,931.4,653.13Z"
          transform="translate(-48.1 -96.1)"
          opacity="0.1"
        ></path>
      </svg>
    </>
  );

}